import config from '../config/config'

export const priceFor = (isMinor: boolean): number =>
  isMinor ? config.CHRISTMAS_DINNER_2026_PRICE_MINOR : config.CHRISTMAS_DINNER_2026_PRICE_ADULT
